<template>
    <div>
        <el-autocomplete v-if="canEdit" v-model="vo[type]" :fetch-suggestions="querySearch"
            :placeholder="'请输入' + placeholder" :trigger-on-focus="false" popper-class="history-autocomplete-popper"
            highlight-first-item @select="handleSelect" @keyup.enter.native="handleSaveHistory">
            <template slot-suffix>
                <i class="el-icon-edit el-input__clear" title="按回车保存到历史" @click="handleSaveHistory"></i>
            </template>
            <template slot-scope="{ item }">
                <div class="history-item">
                    <!-- <i class="el-icon-time history-icon"></i> -->
                    <span class="history-text">{{ item.value }}</span>
                    <!-- <i class="el-icon-close history-delete" title="删除" @click.stop="deleteHistory(item.value)"></i> -->
                </div>
            </template>
        </el-autocomplete>
        <div v-else>{{ vo[type] || '' }}</div>
    </div>

</template>

<script>
export default {
    name: 'InputWithHistory',
    props: {
        vo: {
            type: Object,
            default: () => ({})
        },
        canEdit: { type: Number, default: 1 },
        type: { type: String, default: 'recAccout' },
        placeholder: { type: String, default: '收款信息' }
    },
    data() {
        return {
            inputValue: '',
            historyKey: 'testInputHistory',
            historyList: []
        }
    },
    // watch: {
    //     inputValue: {
    //         handler(newVal, oldVal) {
    //             if (newVal !== oldVal) {
    //                 this.vo[this.type] = newVal
    //             }
    //         },
    //         immediate: true
    //     }
    // },
    mounted() {
        this.historyKey = this.type + 'History'
        this.loadHistory()
    },
    methods: {
        loadHistory() {
            const history = localStorage.getItem(this.historyKey)
            if (history) {
                this.historyList = JSON.parse(history)
            }
        },
        saveHistory(value) {
            debugger
            if (!value || value.trim() === '') return

            const index = this.historyList.indexOf(value)
            if (index > -1) {
                this.historyList.splice(index, 1)
            }

            this.historyList.unshift(value)

            if (this.historyList.length > 10) {
                this.historyList = this.historyList.slice(0, 10)
            }

            localStorage.setItem(this.historyKey, JSON.stringify(this.historyList))
        },
        querySearch(queryString, cb) {
            const results = queryString
                ? this.historyList.filter(item => item.toLowerCase().includes(queryString.toLowerCase()))
                : this.historyList
            const formattedResults = results.map(item => ({ value: item }))
            cb(formattedResults)
        },
        handleSelect(item) {
            this.vo[this.type] = item.value
        },
        handleSaveHistory() {
            this.saveHistory(this.vo[this.type])
            // this.$message.success('已保存到历史记录')
        },
        deleteHistory(value) {
            const index = this.historyList.indexOf(value)
            if (index > -1) {
                this.historyList.splice(index, 1)
                localStorage.setItem(this.historyKey, JSON.stringify(this.historyList))
            }
        }
    }
}
</script>

<style scoped lang="scss">
.el-autocomplete {
    display: flex;
}

.history-item {
    display: flex;
    align-items: center;
    // padding: 8px 0;
    cursor: pointer;

    .history-icon {
        color: #909399;
        margin-right: 8px;
        font-size: 14px;
    }

    .history-text {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .history-delete {
        color: #909399;
        opacity: 0;
        transition: opacity 0.2s;
        font-size: 12px;
        cursor: pointer;

        &:hover {
            color: #f56c6c;
        }
    }

    &:hover .history-delete {
        opacity: 1;
    }
}
</style>

<style lang="scss">
.history-autocomplete-popper {
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    border: 1px solid #e4e7ed !important;
    padding: 4px 0 !important;

    .el-autocomplete-suggestion__wrap {
        padding: 4px 0;
    }

    li {
        line-height: 36px !important;
        padding: 0 12px !important;

        &:hover {
            background-color: #f5f7fa !important;
        }

        &.highlighted {
            background-color: #ecf5ff !important;
        }
    }

    .popper__arrow {
        display: none;
    }
}
</style>
